import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MapViewModule } from "./components/map-view/map-view.module";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { RoutesService } from './services/routes.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG, PrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material-compat'; // calibrated for a 14px root font size (PrimeNG 22 assumes 16px)
import { TimelineModule } from 'primeng/timeline';
import { environment } from 'src/environments/environment';

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        MapViewModule,
    ], providers: [
            RoutesService,
            provideHttpClient(withXhr(), withInterceptorsFromDi()),
            providePrimeNG({
                theme: {
                    preset: Material,
                    options: {
                        darkModeSelector: false
                    }
                },
                ripple: true,
                license: environment.primeLicense
            }),
        ]
})
export class AppModule { }
